import service from '@/store/services/settings/departments-service';

const state = {
    list: {},
    department: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, department) => {
        state.department = department;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(department => {
                commit('SET_RESOURCE', department);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(department => {
                commit('SET_RESOURCE', department);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((department) => {
                commit('SET_RESOURCE', department);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((department) => {
                commit('SET_RESOURCE', department);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    department: state => state.department,
    dropdown: (state) => {
        return state.list.map(department => ({
            id: department.id,
            name: department.name,
            short_name: department.short_name,
            code: department.code,
            port_id: department.port_id
        }));
    }
};

const departments = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default departments;
